<mat-grid-list class="grid-cronograma" cols="2" rowHeight="3:1" >         
    <mat-grid-tile>                    
        <mat-card  [ngClass]=" 
        {'card-cronograma':true,
        'card-opacity': etapaJardin < 1}">
            <mat-card-content>
                <div class="card-contenido">
                    <div class="card-indicador cronograma_capacitacion">
                        <h1>1</h1>
                    </div>
                    <div class="card-informacion">
                        <div class="card-estado">
                            <div class="info_estado">
                                <label class="label-estado">ESTADO:</label>
                                <label [ngClass]=" 
                                {'estado':true,
                                'estado-enEspera': etapaJardin < 1,
                                'estado-enProceso': etapaJardin === 1, 
                                'estado-finalizado': etapaJardin > 1}">
                                    {{ (etapaJardin === 1) ? "En Curso"  : "Finalizada" }}
                                </label>
                            </div>
                            
                        </div>
                        <div class="card-texto">
                            <h2 class="label_capacitacion">Capacitación</h2>
                            <p>
                                Usted será convocada próximamente a participar de una jornada de capacitación presencial.
                            </p>
                        </div>                    
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card [ngClass]=" 
        {'card-cronograma':true,
        'card-opacity': etapaJardin < 2}">
            <mat-card-content>
                <div class="card-contenido">
                    <div class="card-indicador cronograma_autoevaluacion">
                        <h1>2</h1>
                    </div>
                    <div class="card-informacion">
                        <div class="card-estado">
                            <div class="info_estado">
                                <label class="label-estado">ESTADO:</label>
                                <label [ngClass]=" 
                                {'estado':true,
                                'estado-enEspera': etapaJardin < 2,
                                'estado-enProceso': etapaJardin === 2, 
                                'estado-finalizado': etapaJardin > 2}">
                                    {{ (etapaJardin < 2) ? "Pendiente"  : (etapaJardin === 2) ? "En curso" : "Finalizada"}}
                                </label>
                            </div>                                        
                        </div>
                        <div class="card-texto">
                            <h2 class="label_autoevaluacion">Autoevaluación</h2>
                            <p>
                                Una vez que se haya capacitado presencialmente, contará con un plazo de 10 días hábiles para completar y enviar la Guía de Autoevaluación.
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card [ngClass]=" 
        {'card-cronograma':true,
        'card-opacity': etapaJardin < 3}">
            <mat-card-content>
                <div class="card-contenido">
                    <div class="card-indicador cronograma_validacion">
                        <h1>3</h1>
                    </div>
                    <div class="card-informacion">
                        <div class="card-estado">
                            <div class="info_estado">
                                <label class="label-estado">ESTADO:</label>
                                <label [ngClass]=" 
                                {'estado':true,
                                'estado-enEspera': etapaJardin < 3,
                                'estado-enProceso': etapaJardin === 3, 
                                'estado-finalizado': etapaJardin > 3}">
                                    {{ (etapaJardin < 3) ? "Pendiente"  : (etapaJardin === 3) ? "En curso" : "Finalizada"}}
                                </label>
                            </div>
                            
                        </div>
                        <div class="card-texto">
                            <h2 class="label_validacion">Validación</h2>
                            <p>
                                Una vez que haya completado y enviado la Guía de Autoevaluación, podrá ser contactada para agendar la visita de Validación.
                            </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card [ngClass]=" 
        {'card-cronograma':true,
        'card-opacity': etapaJardin < 4}">
            <mat-card-content>
                <div class="card-contenido">
                    <div class="card-indicador cronograma_retroalimentacion">
                        <h1>4</h1>
                    </div>
                    <div class="card-informacion">
                        <div class="card-estado">
                            <div class="info_estado">
                                <label class="label-estado">ESTADO:</label>
                                <label [ngClass]=" 
                                {'estado':true,
                                'estado-enEspera': etapaJardin < 4,
                                'estado-enProceso': etapaJardin === 4, 
                                'estado-finalizado': etapaJardin > 4}">
                                    {{ (etapaJardin < 4) ? "Pendiente"  : (etapaJardin === 4) ? "En curso" : "Finalizada"}}
                                </label>
                            </div>
                            
                        </div>
                        <div class="card-texto">
                        <h2 class="label_retroalimentacion">Retroalimentación</h2>
                        <p>
                            Una vez que haya completado y enviado la Guía de Autoevaluación, podrá ser contactada para agendar la visita de Validación.
                        </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card [ngClass]=" 
        {'card-cronograma':true,
        'card-opacity': etapaJardin < 4}">
            <mat-card-content>
                <div class="card-contenido">
                    <div class="card-indicador cronograma_apelacion">
                        <h1>5</h1>
                    </div>
                    <div class="card-informacion">
                        <div class="card-estado">
                            <div class="info_estado">
                                <label class="label-estado">ESTADO:</label>
                                <label [ngClass]=" 
                                {'estado':true,
                                'estado-enEspera': etapaJardin < 4,
                                'estado-enProceso': etapaJardin === 4, 
                                'estado-finalizado': etapaJardin > 4}">
                                    {{ (etapaJardin < 4) ? "Pendiente"  : (etapaJardin === 4) ? "En curso" : "Finalizada"}}
                                </label>
                            </div>
                            
                        </div>
                        <div class="card-texto">
                        <h2 class="label_apelacion">Apelación</h2>
                        <p>
                            Una vez que haya conocido el Informe de Retroalimentación, dispondrá de un plazo máximo de 3 días hábiles para apelar voluntariamente.
                        </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card [ngClass]=" 
        {'card-cronograma':true,
        'card-opacity': etapaJardin < 6}">
            <mat-card-content>
                <div class="card-contenido">
                    <div class="card-indicador cronograma_plan">
                        <h1>6</h1>
                    </div>
                    <div class="card-informacion">
                        <div class="card-estado">
                            <div class="info_estado">
                                <label class="label-estado">ESTADO:</label>
                                <label [ngClass]=" 
                                {'estado':true,
                                'estado-enEspera': etapaJardin < 6,
                                'estado-enProceso': etapaJardin === 6, 
                                'estado-finalizado': etapaJardin > 6}">
                                    {{ (etapaJardin < 6) ? "Pendiente"  : (etapaJardin === 6) ? "En curso" : "Finalizada"}}
                                </label>
                            </div>
                            
                        </div>
                        <div class="card-texto">
                        <h2 class="label_plan">Plan de Mejoramiento</h2>
                        <p>
                            Las fechas y plazos para desarrollar el Plan de Mejoramiento le serán informados oportunamente.
                        </p>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
</mat-grid-list>